import * as storage from '../persistance/storage';
import * as authConstants from '../constants/auth';

export default function isLoggedIn() {

	let token = storage.get('token');
	let expiry = null;
	try {
		expiry = parseInt(storage.get('tokenExpiry'));
	} catch(error) {
		return false;
	}

	if(!token || token.length < 24) {
		return false;
	}
	if(!expiry || expiry < Date.now()) {
		return false;
	}
	return true;
}

export function isAdmin() {
	let user = storage.get('authUser');
	if(!user) {
		return false;
	}
	let userObj = JSON.parse(user);
	if(userObj && userObj.locations && userObj.locations.length > 0) {
		if(userObj.locations[0].name == 'Headquarters') {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
	return false;
}

export function saveLogin(token) {
	storage.put('token', token);
	storage.put('tokenExpiry', Date.now() + authConstants.LOGOUT_TIME);
}

export function saveUser(user) {
	storage.put('authUser', JSON.stringify(user));
}

export function logout() {
	storage.clear();
}